/**
 * Logos d'entreprise préréglés (choix à la création, en plus de l'import).
 * 12 emplacements prévus — les logos non utilisés par l'apprenant servent
 * d'identité aux enseignes concurrentes (voir utils/parc.js → logoEnseigne).
 */
export const COMPANY_LOGOS = [
  { id: 1, src: '/company-logos/logo-01.png', nom: 'Sac shopping', nomEn: 'Shopping bag' },
  { id: 2, src: '/company-logos/logo-02.png', nom: 'Feuille bio', nomEn: 'Green leaf' },
  { id: 3, src: '/company-logos/logo-03.png', nom: 'Maison & déco', nomEn: 'Home & deco' },
  { id: 4, src: '/company-logos/logo-04.png', nom: 'Mode', nomEn: 'Fashion' },
  { id: 5, src: '/company-logos/logo-05.png', nom: 'Panier frais', nomEn: 'Fresh basket' },
  { id: 6, src: '/company-logos/logo-06.png', nom: 'Vague bleue', nomEn: 'Blue wave' },
  { id: 7, src: '/company-logos/logo-07.png', nom: 'Cube orange', nomEn: 'Orange cube' },
  { id: 8, src: '/company-logos/logo-08.png', nom: 'Pétales', nomEn: 'Petals' },
  { id: 9, src: '/company-logos/logo-09.png', nom: 'Prestige nature', nomEn: 'Premium leaf' },
  { id: 10, src: '/company-logos/logo-10.png', nom: 'Monogramme M', nomEn: 'M monogram' },
  { id: 11, src: '/company-logos/logo-11.png', nom: 'Caddie express', nomEn: 'Express cart' },
  { id: 12, src: '/company-logos/logo-12.png', nom: 'Anneau vif', nomEn: 'Color ring' },
];

export const getCompanyLogo = (id) => COMPANY_LOGOS.find((l) => l.id === id) || null;
